import { Badge } from '@/components/ui/badge';
import { useGameImage } from '@/hooks/useGameImage';
import type { Game } from '@/models/game';

export const GameImage = ({ game }: { game: Game }) => {
  const { getGameImage } = useGameImage();

  return (
    <img
      draggable={false}
      className="w-full max-h-48 object-cover rounded-sm"
      alt={game.name}
      src={game.image ?? getGameImage(game.game_code)}
    />
  );
};

export const GameMiniature = ({ game }: { game: Game }) => {
  return (
    <article className="group relative overflow-hidden rounded-lg border border-gray-200 bg-sidebar shadow-sm transition-all duration-300 hover:shadow-lg hover:border-gray-300 h-80 flex flex-col">
      {/* Header with title and studio - fixed height */}
      <div className="flex items-start justify-between p-4 pb-2 min-h-16">
        <h2 className="text-lg font-semibold text-sidebar-primary-foreground line-clamp-2 flex-1 mr-2">
          {game.name}
        </h2>
        <Badge variant="secondary" className="shrink-0">
          {game.studio}
        </Badge>
      </div>

      {/* Image container - takes remaining space */}
      <div className="flex-1 p-4 pt-2 flex items-center justify-center">
        <div className="w-full max-w-[200px] relative overflow-hidden rounded-md">
          <GameImage game={game} />
        </div>
      </div>
    </article>
  );
};
